import store from "@/store"
import { PermissionUser } from "@/constants/permission-user"

export default {
  methods: {
    getUserPermissions() {
      const permissions = store.state.authStore?.user?.profile?.permissions
      if (!permissions) return []
      return Array.isArray(permissions) ? permissions : permissions.split(",")
    },

    getModuleFirstReadPermission(moduleParam) {
      const moduleUpperCase = moduleParam?.toUpperCase()
      const userPerms = this.getUserPermissions()

      const modulePermissions = PermissionUser[moduleUpperCase]
      if (!modulePermissions) return null

      const orderedReadPermissions = Object.values(modulePermissions).filter(
        (perm) => perm.endsWith(":read")
      )

      return (
        orderedReadPermissions.find((perm) => userPerms.includes(perm)) || null
      )
    },

    hasPermission(permission) {
      if (!permission || permission === "login") return true
      return this.getUserPermissions().includes(permission)
    },

    hasModulePermission(moduleParam) {
      const moduleLowerCase = moduleParam?.toLowerCase()
      return this.getUserPermissions().some((perm) =>
        perm.startsWith(`${moduleLowerCase}.`)
      )
    },
  },
}
